import React from "react";

import { Phone } from "lucide-react";

import "./Lienhe.css";

const Lienhe = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* CONTACT CONTENT */}

        <div className="contact-content">
          <h2>CẦN RÚT ĐÁO</h2>

          <p>Liên hệ ngay để được tư vấn và báo phí tốt nhất!</p>
        </div>

        {/* CALL BUTTON */}

        <a href="tel:0941342598" className="contact-call">
          <Phone size={22} fill="white" />

          <div className="contact-call-text">
            <strong>GỌI NGAY: 0941 342 598</strong>

            <span>Hỗ trợ 24/7 - Có mặt tận nơi</span>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Lienhe;
